import PropTypes from 'prop-types';

export default {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired
};
